type SlackChannel = {
  name: string;
  description: string | null;
};

type Props = {
  channels: SlackChannel[];
};

export function SlackChannelInfo({ channels }: Props) {
  if (channels.length === 0) {
    return (
      <div className="rounded-lg border bg-muted/20 p-6 text-center text-sm text-muted-foreground">
        Nenhum canal do Slack configurado.
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {channels.map((c) => (
        <div key={c.name} className="rounded-lg border bg-card p-4">
          <div className="font-mono text-sm font-semibold">#{c.name}</div>
          {c.description && <p className="mt-1 text-sm text-muted-foreground">{c.description}</p>}
        </div>
      ))}
    </div>
  );
}
